import React, {useState} from "react"
import { FaEnvelope, FaLock } from 'react-icons/fa'
import {useDispatch} from "react-redux"
import {navigate} from "gatsby"

import "./login.scss"
import Layout from "../components/layout"
import SEO from "../components/seo"
import Image from "../components/image"
import Header from "../components/header/header"
import Footer from "../components/footer/footer"
import ResetPassword from "../containers/resetPassword/resetPassword"
import {login} from "../redux/api/apiAction"
import {loginCoordinator} from "../redux/group/groupAction";


const LoginPage = () => {
    const dispatch = useDispatch()

    const [success, setSuccess] = useState(false)
    const [error, setError]     = useState(false)
    const [isCoordinator, setIsCoordinator] = useState(false)

    const [password, setPassword]   = useState(process.env.NODE_ENV !== 'production' ? "sdf" : "")
    const [email, setEmail]         = useState(process.env.NODE_ENV !== 'production' ? "antoine.delagarcie@gmail.com" : "")

    const [validationPassword, setValidationPassword]   = useState("")
    const [validationEmail, setValidationEmail]         = useState("")

    const onChange = e => {
        const {name, value} = e.target
        name === "email" ? setEmail(value) : setPassword(value)
    }

    const checkValidation = () => {
        if(email === "")
            setValidationEmail("Enter your email")
        else
            setValidationEmail("")

        if(password === "")
            setValidationPassword("Enter your password")
        else
            setValidationPassword("")

        return email.length > 0 && password.length > 0
    }

    const onSubmit = e => {
        e.preventDefault()

        if(checkValidation()) {
            if(isCoordinator){
                dispatch(loginCoordinator(email, password))
                    .then(res => {
                        if(res === true) {
                            setEmail("")
                            setPassword("")
                            setSuccess(true)
                            setError(false)
                            navigate("group")
                        }
                        else {
                            setSuccess(false)
                            setError(true)
                        }
                    })
            }
            else {
                dispatch(login(email, password))
                    .then(res => {
                        if(res === true) {
                            setEmail("")
                            setPassword("")
                            setSuccess(true)
                            setError(false)
                            navigate("non-member-single")
                        }
                        else {
                            setSuccess(false)
                            setError(true)
                        }
                    })
            }
        }
        else {
            setSuccess(false)
            setError(true)
        }
    }

    return (
        <Layout main={false} className={"login"}>
            <SEO title="Login" />

            <Header title={null}
                    subtitle={"Log in to your account"}
                    image={<Image className={"img-fluid"} filename={"union_square.png"} alt={"Union"}/>}
            />

            <form onSubmit={onSubmit}>
                <div className="form-row">
                    <div className={"col-1"}>
                        <label><FaEnvelope/></label>
                    </div>
                    <div className={"col-11"}>
                        <input type="email" className="form-control" placeholder="Email" name={"email"} value={email} onChange={onChange} required/>
                        {validationEmail.length > 0 ?
                            <div className="invalid-feedback">
                                {validationEmail}
                            </div> : ""}
                    </div>
                </div>
                <div className="form-row">
                    <div className={"col-1"}>
                        <label><FaLock/></label>
                    </div>
                    <div className={"col-11"}>
                        <input type="password" className="form-control" placeholder="Password" name={"password"} value={password} onChange={onChange} required/>
                        {validationPassword.length > 0 ?
                            <div className="invalid-feedback">
                                {validationPassword}
                            </div> : ""}
                    </div>
                </div>
                <div className="form-row">
                    <div className={"col-1"}>
                        <input type="checkbox" id={"isCoordinator"} className="form-control" placeholder="Coordinator" name={"isCoordinator"} value={isCoordinator} onChange={() => setIsCoordinator(prev => !prev)}/>
                    </div>
                    <div className={"col-11"}>
                        <label htmlFor={"isCoordinator"}>Are you a coordinator ?</label>
                    </div>
                </div>

                <div className={"form-row"}>
                    {error ?
                        <div className="error invalid-feedback">
                            Error during connection
                        </div>
                    : ""}

                    {success ?
                        <div className="success valid-feedback">
                            Connection succeeded
                        </div>
                        : ""}
                </div>
            </form>

            <Footer button={"Log in"} isButton={true} buttonAction={onSubmit}>
                <ResetPassword isCoordinator={isCoordinator}/>
            </Footer>
        </Layout>
    )
}

export default LoginPage
